import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';

export const FundOpportunityFieldReasoningIcon: React.FC<{ field: unknown }> = ({ field }) => {
  if (!field || typeof field !== 'object' || !('reasoning' in field)) {
    return null;
  }

  const reasoning = (field as { reasoning?: { file: string; page: string; quote: string } })
    .reasoning;
  if (!reasoning) return null;

  return (
    <Tooltip
      title={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
          <Typography variant="caption">{`File: ${reasoning.file}`}</Typography>
          <Typography variant="caption">{`Page: ${reasoning.page}`}</Typography>
          <Typography variant="caption">{`Quote: ${reasoning.quote}`}</Typography>
        </Box>
      }
      placement="top"
      arrow
    >
      <Box component="span" sx={{ display: 'inline-flex', ml: 0.75 }}>
        <HelpOutlineIcon sx={{ fontSize: 16, color: Palette.tone1.text }} />
      </Box>
    </Tooltip>
  );
};
